import qs from 'query-string';
import getReturnUrl from 'shared/universal/get-return-url';

export const getJoinUrl = (search) => {
  const base = '/account/create';
  const incomingQueryParams = qs.parse(search);
  const returnUrl = getReturnUrl(incomingQueryParams);

  if (returnUrl) {
    const encodedReturnUrl = encodeURIComponent(returnUrl);
    return `${base}?returnUrl=${encodedReturnUrl}`;
  }
  return base;
};
